import { invoiceAPI } from '../../api/services/invoice'

const invoicesSummary = async (fromDate: string, toDate: string) => {
  try {
    const response = await invoiceAPI.getInvoicesSummary(fromDate,toDate)

    if (response.error) {
      return null
    }

    const data = response.data

    if (data) {
      return data
    }
  } catch {
    return null
  }
}

export default invoicesSummary
